export const PRIMARY = "#2F7A8A";
export const VIOLET = "#5F6FA0";
export const GRAY = "#7A766C";
export const MUTED = "#A5A196";
export const BORDER = "#EAE8E2";
export const BG = "#F5F4F0";
export const RED = "#DC6A4C";
export const ORANGE = "#E0A84C";
export const FG1 = "#1F1E1A";
export const FG2 = "#48453E";
export const FG3 = "#7A766C";
export const STEEL = "#6B6F88";
export const GOLD = "#D4A017";
